import { render, staticRenderFns } from "./ChatEmailInput.vue?vue&type=template&id=2bbd9dca&"
import script from "./ChatEmailInput.vue?vue&type=script&lang=js&"
export * from "./ChatEmailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports